import { Button } from "@alpacahq/ui/old";

import { useLocalStorage } from "~/v2/hooks/useLocalStorage";

export const ErrorTesting = () => {
  const [errorTestingOpen, setErrorTestingOpen] = useLocalStorage<boolean>(
    "devtools-error-testing-open",
  );

  return (
    <div className="overflow-hidden rounded border border-gray-300">
      <button
        type="button"
        onClick={() => setErrorTestingOpen(!(errorTestingOpen ?? false))}
        className="flex w-full items-center justify-between bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100"
      >
        <h2 className="m-0 font-semibold text-lg">Error Testing</h2>
        <span className="text-gray-500">
          {(errorTestingOpen ?? false) ? "−" : "+"}
        </span>
      </button>
      {(errorTestingOpen ?? false) && (
        <div className="p-4">
          <div className="flex flex-row gap-2">
            <Button
              variant="red"
              onClick={() => {
                throw new Error("Test error");
              }}
            >
              Throw an error
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
